// src/pages/LoginPage.js
import React from "react";
import LoginForm from "../components/LoginForm";
import { useNavigate } from "react-router-dom";
import styles from "../css/Login.module.css";

const LoginPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.pageContainer}>
      <LoginForm onLogin={() => navigate("/dashboard")} />
    </div>
  );
};

export default LoginPage;
